import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const LOGO = "https://customer-assets-4nw71qhi.emergentagent.net/job_812982a3-d68d-4e95-898f-ce895a06fb5f/artifacts/cdeb5a53f4c380bd_logo%20%286%29.png";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/")) {
      localStorage.removeItem("mm_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const roleStyle = (color = "#94A3B8") => ({ color, backgroundColor: `${color}1A`, borderColor: `${color}4D` });

export const CONTENT_TYPES = {
  quiz: { label: "Quiz", color: "#FF6B00" },
  mocks: { label: "Mock", color: "#06B6D4" },
  batch_annotated: { label: "Batch-Annotated File", color: "#A855F7" },
  practice_sheet: { label: "Practice Sheet", color: "#10B981" },
  book: { label: "Book", color: "#EC4899" },
  digital_notes: { label: "Digital Notes", color: "#EAB308" },
};

export const fmtDate = (s) => (s ? new Date(s).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtDay = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString(undefined, { dateStyle: "medium" }) : "—");
export const isManager = (u) => u.is_admin || u.roles.includes("manager");
